export function single(gauge) {
  if (Array.isArray(gauge)) return gauge[0]
  const { loaded, queries } = gauge
  if (!loaded) return null
  return queries[0].result
}
